const lighterBlueStatuses = ["paid"];
const lighterGreenStatuses = ["approved", "accepted"];
const mediumRedStatuses = ["rejected"];
const lighterYellowStatuses = ["pending"];

export const getStatusDefaultBackgroundCircle = (status: string) => {
    if (lighterBlueStatuses.includes(status)) {
        return "bg-lighterBlue";
    } else if (lighterGreenStatuses.includes(status)) {
        return "bg-mediumGreen";
    } else if (mediumRedStatuses.includes(status)) {
        return "bg-mediumRed2";
    } else if (lighterYellowStatuses.includes(status)) {
        return "bg-mediumYellow";
    } else {
        return "bg-grayPurple";
    }
};

export const getTagDefaultColor = (status: string) => {
    if (lighterBlueStatuses.includes(status)) {
        return "blue";
    } else if (lighterGreenStatuses.includes(status)) {
        return "green";
    } else if (mediumRedStatuses.includes(status)) {
        return "volcano";
    } else if (lighterYellowStatuses.includes(status)) {
        return "yellow";
    } else {
        return "purple";
    }
};
